/**
 * @fileoverview Admin/tables route definitions for CRUD entity management.
 * Routes are generated from the centralized entity registry.
 *
 * Page components are lazy-loaded so the data-grid heavy CRUD page is only
 * fetched when an admin/tables route is visited.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { ENTITY_KEYS, ENTITY_REGISTRY, type EntityKey } from '../../features/admin/registry';
import { createRoutes } from '../utils/routeHelpers';

const TablesHubPage = lazy(() => import('../../features/admin/pages/TablesHubPage'));
const DynamicCrudPage = lazy(() =>
  import('../../features/admin/pages/DynamicCrudPage').then((m) => ({ default: m.DynamicCrudPage }))
);

/**
 * Creates a page component for an entity from the registry.
 */
function createEntityPage(entityKey: EntityKey): React.ComponentType {
  return function EntityPage() {
    return <DynamicCrudPage entityKey={entityKey} />;
  };
}

/**
 * Creates a route definition for an entity from the registry.
 */
function createEntityRoute(entityKey: EntityKey): { path: string; Component: React.ComponentType } {
  const config = ENTITY_REGISTRY[entityKey];
  return {
    path: `tables/${entityKey}/:${config.paramName}?/*`,
    Component: createEntityPage(entityKey),
  };
}

export const adminRoutes: RouteObject[] = createRoutes([
  { path: 'tables', Component: TablesHubPage },
  ...ENTITY_KEYS.map(createEntityRoute),
]);
